import { render } from "./IsoUniversity.vue?vue&type=template&id=3c51df29&scoped=true"
import script from "./IsoUniversity.vue?vue&type=script&lang=js"
export * from "./IsoUniversity.vue?vue&type=script&lang=js"

import "./IsoUniversity.vue?vue&type=style&index=0&id=3c51df29&scoped=true&lang=css"
import "./IsoUniversity.vue?vue&type=style&index=1&id=3c51df29&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c51df29"]])

export default __exports__